<template>
  <a-modal
    :title="title"
    :visible="visible"
    @cancel="handleCancel"
    @ok="handleCancel"
    @close="handleCancel"
    width="1200px">
    <a-table
      bordered
      rowKey="id"
      :columns="addressColumns"
      :data-source="list"
      :customRow="loadCustomRow"
      :pagination="false"
      :loading="loading">
      <span slot="detailedAddress" slot-scope="text, record">{{record.areap}}{{record.areac}}{{record.areax}}{{record.detailedAddress}}</span>
    </a-table>
    <div style="height: 25px">
    </div>
    <div class="bottom-control">
      <a-space>
        <a-button type="dashed" @click="handleCancel">
          {{$t('取消')}}
        </a-button>
      </a-space>
    </div>
  </a-modal>
</template>

<script>
import {subInfo} from '@/api/merchant/extraApplyLakala'

export default {
  name: 'LedgerBindList',
  props: {
  },
  data() {
    return {
      title:undefined,
      loading: false,
      visible: false,
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      filteredInfo: {},
      sortedInfo : {},
      total:0,
      queryParam: {
        id: undefined,
        pageNum: 1,
        pageSize: 10
      },
      list: [],
      addressColumns: [
        {
          title: '渠道',
          dataIndex: 'registerTypeText'
        },
        {
          title: '子商户号',
          dataIndex: 'subMchId'
        },
        {
          title: 'channelId',
          dataIndex: 'channelId'
        },
        /*{
          title: 'registerChannel',
          dataIndex: 'registerChannel'
        },*/
        {
          title: '注册渠道',
          dataIndex: 'registerChannelText'
        },
        {
          title: 'receOrgNo',
          dataIndex: 'receOrgNo'
        },
        {
          title: '注册时间',
          dataIndex: 'registerTm'
        },
        {
          title: '注册状态',
          dataIndex: 'registerStatus'
        },
        {
          title: 'resultMessage',
          dataIndex: 'resultMessage'
        },
      ],
    }
  },
  methods: {
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    handleCancel() {
      this.visible=false
      this.list=[]
      this.reset()
    },

    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    reset() {
      this.form  = {
        orderId: undefined,
        addressId: undefined,
        isAdmin: true
      }
      this.selectedRowKeys=[]
      this.selectedRows = []
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows
    },
    /** 修改按钮操作 */
    handleDetail(id) {
      this.queryParam.id=id
      subInfo(this.queryParam).then(res => {
        this.list = res.data.respData.list
        this.visible = true;
      }).finally(() => {
        this.loading = false
      });
    },
    loadCustomRow (record, index) {
      return {
        on: {
          click: () => {
            // 记录为disabled则直接返回，默认为不可选
            if (this.selectedRowKeys.find(e=>e.id===record.id)) {
              return;
            }
            let selectedRowKeys  = [record.id]
            let selectedRows =[record]
            this.onSelectChange(selectedRowKeys, selectedRows)
          }
        }
      }
    },
    handleOk() {
      this.form.addressId=this.selectedRowKeys[0]
      updateAddress(this.form).then(res => {
        this.$message.success("修改地址成功", 3)
        this.visible = false;
        this.$emit("ok");
      }).finally(() => {
        this.loading = false
      });
    },
  }
}
</script>
